import { FileUploadChunk, FileUploadEvent } from './file-upload.model';

export enum FileUploadState {
  READY,
  PENDING,
  UPLOADING,
  PAUSED,
  FINALIZING,
  COMPLETED,
  ERROR
}

export type FileUploadChunkState = FileUploadChunk & {
  bytesUploaded: number;
  bytesTotal: number;
  progress: number;
  completed: boolean;
  error: boolean;
}

export function creatFileUploadChunkState(fileUploadChunk: FileUploadChunk): FileUploadChunkState {
  return {
    ...fileUploadChunk,
    bytesUploaded: 0,
    bytesTotal: (fileUploadChunk.end - fileUploadChunk.start),
    progress: 0,
    completed: false,
    error: false
  }
}

export function creatFileUploadChunkStateFromEvent(fileUploadChunk: FileUploadChunk, fileUploadEvent: FileUploadEvent): FileUploadChunkState {
  return {
    ...fileUploadChunk,
    ...fileUploadEvent,
    error: false
  }
}

export function createFileUploadChunk(fileUploadChunkState: FileUploadChunkState): FileUploadChunk {
  return {
    position: fileUploadChunkState.position,
    start: fileUploadChunkState.start,
    end: fileUploadChunkState.end,
    url: fileUploadChunkState.url
  }
}
